
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 18V0h15.8v4.8h-1.2V1.2H1.2v15.6h13.4v-3.5h1.2V18H0zm14.7-7.2L16 9.5H6.4v-1H16l-1.2-1.2.8-.8L18 9l-2.5 2.5-.8-.7z"}})])
          )
        }
      }
    